import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Money } from "@/components/shared/Common";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function Pricing() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/pricing").then(r => setP(r.data)); }, []);
  return (
    <div className="cm-container py-14">
      <div className="max-w-2xl mx-auto text-center">
        <div className="cm-eyebrow mb-2">Pricing</div>
        <h1 className="cm-h2">Transparent, before you book.</h1>
        <p className="cm-body mt-3">No hidden fees. Cancel up to 24 hours before your appointment for a full refund.</p>
      </div>
      <div className="mt-10 grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
        <PriceCard title="General consultation" desc="GP consultation for everyday health concerns." price={p?.general_price ?? 50} bullets={["15-minute video consult","Repeat prescriptions where clinically appropriate","Notes to your Care Passport"]} testid="pricing-general"/>
        <PriceCard title="Specialist consultation" desc="Direct access to consultants across 10+ specialties." price={p?.specialist_price ?? 70} highlight bullets={["20-minute video consult","Referrals and diagnostic pathways","Follow-up plan included"]} testid="pricing-specialist"/>
      </div>
      <p className="text-xs text-[#94a3b8] text-center mt-8">All prices in {p?.currency || "GBP"}. Prices configurable via admin.</p>
    </div>
  );
}

const PriceCard = ({ title, desc, price, bullets, highlight, testid }) => (
  <div className={`cm-card ${highlight ? "border-[#4a90d9]/50 ring-2 ring-[#4a90d9]/10" : ""}`} data-testid={testid}>
    <div className="text-sm font-semibold uppercase tracking-wider text-[#4a90d9] mb-2">{title}</div>
    <div className="text-4xl font-bold text-[#1a2b4a]"><Money amount={price}/></div>
    <p className="text-sm text-[#475569] mt-2">{desc}</p>
    <ul className="mt-4 space-y-2 text-sm text-[#475569]">
      {bullets.map(b => <li key={b} className="flex items-start gap-2"><Check size={14} className="text-[#3daa6e] mt-0.5"/>{b}</li>)}
    </ul>
    <Link to="/find-care" className="cm-btn-primary w-full mt-6" data-testid={`${testid}-cta`}>Find a doctor</Link>
  </div>
);
